<script>
import design from '@design'
import _ from 'lodash'
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    inputValue: {
      type: [String, Number, Object],
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    design() {
      return design
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    isChecked(inputValue) {
      if (typeof inputValue === 'object') {
        return this.model.some((item) => _.isEqual(item, inputValue))
      }
      return this.model.includes(inputValue)
    },
    onClickCheckbox(event) {
      if (this.isChecked(this.inputValue) && this.options.preventEmpty) {
        event.preventDefault()
      }
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.checkboxContainer]: true,
      [$style.selected]: isChecked(inputValue),
      [$style.checkboxDisabled]: disabled,
    }"
    :style="{
      '--checkmark-width': options.width ? options.width + 'px' : '20px',
      '--checkmark-height': options.height ? options.height + 'px' : '20px',
      '--checkmark-selected-color': options.color ? options.color : design['primary-blue'],
    }">
    <input
      v-model="model"
      :disabled="disabled"
      type="checkbox"
      v-bind="$attrs"
      :value="inputValue"
      @click="onClickCheckbox" />
    <span v-show="!$attrs.disabled" :class="$style.checkmark" />
    <span v-show="!isChecked(inputValue)" :class="$style.emptyCheckmark" />
    <p class="button-text"
      >{{ label }}
      <slot name="afterLabel" />
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.checkboxContainer {
  position: relative;
  display: flex;
  flex-shrink: 0;
  max-width: 100%;
  color: $dark-gray;

  > input {
    width: var(--checkmark-width, 20px);
    min-width: 20px;
    height: var(--checkmark-height, 20px);
    margin-right: 8px;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid $dark-gray;
    border-radius: 8px;
    appearance: none;
    outline: none;

    &:checked {
      background-color: var(--checkmark-selected-color, $primary-blue);
    }

    &:disabled {
      cursor: default;
      background-color: $white !important;
      border: 1px solid $white;
    }
  }

  .checkmark {
    visibility: hidden;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: var(--checkmark-width, 20px);
      height: var(--checkmark-height, 20px);
      pointer-events: none;
      content: '';
      background: url(~@assets/icons/DoubleCheck.svg) no-repeat center;
      background-size: 70% 70%;
    }
  }

  &.selected {
    color: var(--checkmark-selected-color, $primary-blue);

    > input {
      background-color: var(--checkmark-selected-color, $primary-blue);
      border: 1px solid var(--checkmark-selected-color, $primary-blue);

      &:disabled {
        border: 1px solid $white;
      }
    }

    > .checkmark {
      visibility: visible;
    }
  }

  > p {
    color: currentColor;
  }

  &.checkboxDisabled {
    > .checkmark {
      &::after {
        background: url(~@assets/icons/BlueDoubleCheck.svg) no-repeat center;
      }
    }

    > .emptyCheckmark {
      visibility: visible;

      &::after {
        position: absolute;
        top: 8px;
        left: 0;
        width: 20px;
        height: 5px;
        pointer-events: none;
        content: '';
        background: url(~@assets/icons/checkboxX.svg) no-repeat center;
      }
    }
  }
}
</style>
